import type { AllRouteEndpoints } from "../routeTypes";

export const appGroupsAppGroupIdPlacementsId = "/app_groups/:app_group_id/placements/:id";

export const appGroupsAppGroupIdPlacementsIdCacheKeys: AllRouteEndpoints[] = [
  "/app_groups/:app_group_id/placements/:id",
  "/app_groups/:app_group_id/placements",
];
